export default [
    {
        // [0]
        key: "name",
        label: app.$i18n.t("Event"),
        visible: true,
    },
    {
        // [1]
        key: "users",
        label: app.$i18n.t("Recipients"),
        visible: true,
    },
    {
        // [1]
        key: "groups",
        label: app.$i18n.t("Recipients Group"),
        visible: true,
    },
    {
        // [1]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
    },
]